import React, { useState } from "react";
import { Input } from "../../ui/input";
import { Button } from "../../ui/button";


const WordEditComponent = ({ challenge, date, game_id, onCancel, onSaved }) => {
  const [value, setValue] = useState(challenge || "");
  const [isSaving, setIsSaving] = useState(false);

    const updateChallenge = (gameId, date, newChallenge) => {
      return fetch(process.env.REACT_APP_CMC_API + "/statistics", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          method: "updateDailyChallenge",
          game: gameId,
          date: date,
          info: newChallenge,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to update challenge");
          }
        })
        .catch((error) => {
          console.error("Error updating challenge:", error);
        });
    };

  const handleSave = async () => {
    setIsSaving(true);
    await updateChallenge(game_id, date, value);
    setIsSaving(false);
    if (onSaved) onSaved();
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
  };

  return (
        <div className="flex flex-col gap-2 w-full">
          <Input
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="mt-2 bg-[#ffffff] dark:bg-neutral-800"
            placeholder="Enter challenge value"
            autoFocus
          />
          <div className="flex gap-2 mt-2">
            <Button
              className="bg-gray-50 hover:bg-gray-200 dark:bg-neutral-700 dark:hover:bg-neutral-600 transition-colors shadow-none p-2 min-w-0"
              onClick={handleSave}
              disabled={isSaving}
            >
              <svg width="20" height="20" fill="none" stroke="#22c55e" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7"/></svg>
            </Button>
            <Button
              className="bg-gray-50 hover:bg-gray-200 dark:bg-neutral-700 dark:hover:bg-neutral-600 transition-colors shadow-none p-2 min-w-0"
              variant="ghost"
              onClick={handleCancel}
              disabled={isSaving}
            >
              <svg width="20" height="20" fill="none" stroke="#F8A5A5" strokeWidth="2" viewBox="0 0 24 24"><path d="M6 18L18 6M6 6l12 12"/></svg>
            </Button>
          </div>
        </div>
  );
};

export default WordEditComponent; 